import { useCallback } from 'react'
import { toast } from 'sonner'
import { useAppDispatch } from '@/store/hooks'
import { setSaveStatus } from '@/features/editor/editorSlice'
import { parseBlockError } from '@/features/editor/lib/parseBlockError'
import { getErrorMessage } from '@/store/errorToastMiddleware'

// Отказ сервера, по которому `errorToastMiddleware` уже показал свой тост: второй — сырым
// текстом бэка — дублировал его (bbvqs). Где общий тост молчит, остаётся наш.
export const toastedByMiddleware = (e: unknown): boolean =>
  typeof e === 'object' &&
  e !== null &&
  'status' in e &&
  getErrorMessage(e as Parameters<typeof getErrorMessage>[0], '', true) !== null

// Wraps an editor mutation: saving → saved, or error + toast on failure.
// Возвращает УСПЕХ: вызывающие, которые удаляют блоб из хранилища
// (место картинки урока), обязаны дождаться прошедшего PUT — иначе при
// 403/сети файл уже удалён, а урок всё ещё на него ссылается.
export const useSaveStatusWrap = () => {
  const dispatch = useAppDispatch()
  return useCallback(
    async (p: Promise<unknown>, errMsg: string): Promise<boolean> => {
      dispatch(setSaveStatus('saving'))
      try {
        await p
        dispatch(setSaveStatus('saved'))
        return true
      } catch (e) {
        dispatch(setSaveStatus('error'))
        if (!toastedByMiddleware(e)) toast.error(parseBlockError(e, errMsg))
        return false
      }
    },
    [dispatch],
  )
}
